import { toast } from "react-toastify"
import { FetchApi } from "../../../api/fetch"
import { ENDPOINT } from "../../../constants"
import { Notification } from "../../../components/Notification"
import { Blockchain } from "../ManageDraft/types"
import { Collection, } from "../../../types"
import { CollectionProps } from "./types"

export const updateCollection = async (
  collectionData: Collection,
  collectionProps: CollectionProps
) => {

  const {
    name,
    description,
    candyMachineAddresses,
    website,
    twitter,
    discord,
    tiktok,
    instagram,
    medium,
    isDerivative,
    isNsfw,
    links,
    youtube,
    twitch,
    subber,
    atlas3,
    thumbnailUrl,
    bannerUrl,
    verifeyed,
    creatorEmail,
    collectionKey,
    blockchain
  } = collectionData
  const {
    mintHashList,
    collectionThumbnail,
    setIsLoadingOverlayDisplay,
    collectionThumbnailName,
    collectionBannerName,
    collectionBanner,
    isReplaceMintList,
    collectionId,
    updateNameCheck,
    thumbnailFile,
    bannerFile,
    mintFile,
    uploadFile
  } = collectionProps

  const special_tag_list = []
  isNsfw && special_tag_list.push("NSFW")
  isDerivative && special_tag_list.push("DERIVATIVE")


  if (!Boolean(updateNameCheck === name)) {
    toast.error(
      <Notification
        title="Updating names is not supported at this time."
        description="Unfortunately we do not support the updating of names at this current time."
      />
    )
    return
  }



  setIsLoadingOverlayDisplay(true)

  if (mintHashList && mintFile) {
    // await uploadFile(
    //   mintFile,
    // )
  }

  if (collectionThumbnail && thumbnailFile) {
    await uploadFile(
      thumbnailFile,
    )
  }

  if (collectionBanner && bannerFile) {
    await uploadFile(
      bannerFile,
    )
  }

  const userJWT = JSON.parse(sessionStorage.getItem('userData') || '{}').token

  const urlBase = "https://creator-portal-bucket.s3.us-east-2.amazonaws.com"
  let payload = {
    name: name,
    description: description,
    website: website?.length > 0 ? website : undefined,
    discord: discord?.length > 0 ? discord : undefined,
    twitter: twitter?.length > 0 ? twitter : undefined,
    medium: medium?.length > 0 ? medium : undefined,
    tiktok: tiktok?.length > 0 ? tiktok : undefined,
    youtube: youtube?.length > 0 ? youtube : undefined,
    instagram: instagram?.length > 0 ? instagram : undefined,
    atlas3: atlas3?.length > 0 ? atlas3 : undefined,
    subber: subber?.length > 0 ? subber : undefined,
    twitch: twitch?.length > 0 ? twitch : undefined,
    thumbnailUrl: Boolean(thumbnailUrl && !collectionThumbnail) ? thumbnailUrl : `${urlBase}/${collectionThumbnailName}`,
    // mintListUrl: hasUploadMintList ? `${urlBase}/${mintHashListName}` : mintListUrl,
    mints: mintHashList?.length > 0 ? mintHashList : undefined,
    candyMachineAddresses,
    collectionKey,
    bannerUrl: Boolean(collectionBanner) ? `${urlBase}/${collectionBannerName}` : bannerUrl,
    special_tag_list: special_tag_list,
    specialTagList: special_tag_list,
    isNsfw,
    isDerivative,
    links: links,
    replace_mint_list: isReplaceMintList,
    replaceMintList: isReplaceMintList,
    verifeyed,
    creatorEmail: creatorEmail?.length > 0 ? creatorEmail : undefined
  }

  const baseURL = blockchain !==  Blockchain.Bitcoin ? ENDPOINT.UPDATE_LIVE_COLLECTION : ENDPOINT.UPDATE_LIVE_COLLECTION + '/ordinals'

  const response = await FetchApi({
    endpoint:`${baseURL}/${collectionId}`, 
    method: "PUT",
    JWT:userJWT,
    body:  (payload)
  })


  return  response

}

export const requestApproval = async (
  collectionData: Collection,
  collectionProps: CollectionProps
) => {
  const {
    name,
    description,
    candyMachineAddresses,
    walletAddressList,
    website,
    twitter,
    discord,
    youtube,
    tiktok,
    instagram,
    medium,
    atlas3,
    subber,
    twitch,
    isDerivative,
    isNsfw,
    links,
    thumbnailUrl,
    bannerUrl,
    verifeyed,
    collectionKey,
    creatorEmail,
  } = collectionData

  const {
    mintHashList,
    collectionThumbnail,
    setIsLoadingOverlayDisplay,
    collectionThumbnailName,
    collectionBannerName,
    collectionBanner,
    isReplaceMintList,
    collectionId,
    updateNameCheck,
    thumbnailFile,
    bannerFile,
    uploadFile,
  } = collectionProps

  const special_tag_list = []
  isNsfw && special_tag_list.push("NSFW")
  isDerivative && special_tag_list.push("DERIVATIVE")


  if (!Boolean(updateNameCheck === name)) {
    toast.error(
      <Notification
        title="Updating names is not supported at this time."
        description="Unfortunately we do not support the updating of names at this current time."
      />
    )
    return
  }



  setIsLoadingOverlayDisplay(true)


  if (collectionThumbnail && thumbnailFile) {
    await uploadFile(
      thumbnailFile,
    )
  }

  if (collectionBanner && bannerFile) {
    await uploadFile(
      bannerFile,
    )
  }

  const userJWT = JSON.parse(sessionStorage.getItem('userData') || '{}').token

  const urlBase = "https://creator-portal-bucket.s3.us-east-2.amazonaws.com"

  const response = await FetchApi({
    endpoint:`${ENDPOINT.BASE_ENDPOINT}/${collectionId}/submit_verification`, 
    method: "POST",
    JWT:userJWT,
    body:  ({
      name: name,
      description: description,
      website: website?.length > 0 ? website : undefined,
      discord: discord?.length > 0 ? discord : undefined,
      twitter: twitter?.length > 0 ? twitter : undefined,
      medium: medium?.length > 0 ? medium : undefined,
      tiktok: tiktok?.length > 0 ? tiktok : undefined,
      youtube: youtube?.length > 0 ? youtube : undefined,
      instagram: instagram?.length > 0 ? instagram : undefined,
      atlas3: atlas3?.length > 0 ? atlas3 : undefined,
      subber: subber?.length > 0 ? subber : undefined,
      twitch: twitch?.length > 0 ? twitch : undefined,
      thumbnailUrl: Boolean(thumbnailUrl && !collectionThumbnail) ? thumbnailUrl : `${urlBase}/${collectionThumbnailName}`,
      mints: mintHashList?.length > 0 ? mintHashList : undefined,
      wallet_address_list: walletAddressList,
      candyMachineAddresses,
      collectionKey,
      bannerUrl: Boolean(collectionBanner) ? `${urlBase}/${collectionBannerName}` : bannerUrl,
      special_tag_list: special_tag_list,
      specialTagList: special_tag_list,
      isNsfw,
      isDerivative,
      links: links,
      replace_mint_list: isReplaceMintList,
      verifeyed,
      creatorEmail: creatorEmail?.length > 0 ? creatorEmail : undefined
    })
  })

  return await response.json() || response
}

